/**
 * На вход получаем HTML, на выход - его же, но с заменой чисел типа "12 000" на `<span aria-label="12.000"/><span aria-hidden="12 000"/>`.
 * Это нужно для скринридеров, чтобы они не читали "двенадцать три ноля", а читали "двенадцать тысяч".
 * Тестирование: `node processAriaDigits.manual-test.mjs`
 * @param {string} inputHtml
 * @returns {string}
 */

export default function processAriaDigits(inputHtml) {
	let finalHtml = '';
	let processedInputEndIndex = 0;
	for (const matchObject of inputHtml.matchAll(/(\d{1,3})([ ]\d{3})+(\d)*/g)) {
		const number = matchObject[0];
		// if (!number) continue; // Для подстраховки, а то хз как себя ведет этот RegExpStringIterator, вдруг будут пустые результаты
		/** Индекс начала найденной подстроки в исходном ХТМЛ */
		const startIndex = matchObject['index'];
		/** Индекс конца найденной подстроки в исходном ХТМЛ */
		const endIndex = startIndex + number.length;

		// проверка, что найденной подстроке не предшествует markerStr, т.е. число уже не обработано
		const isAriaMarker = 'aria-hidden="true">';
		const isAria = inputHtml.slice(startIndex - isAriaMarker.length, startIndex) === isAriaMarker;

		// проверка, что перед найденной подстрокой не стоит плюсик, предваряемый пробелом/переносом/скобкой тега
		const isPhone = /[\s|>]\+/.test(inputHtml.slice(startIndex - 2, startIndex));

		// проверка, что число находится не внутри хтмл атрибута (или, по сути, тега)
		/** Фрагмент исходного ХТМЛ перед найденной подстрокой */
		const beforeString = inputHtml.slice(0, startIndex);
		const lastOpenBefore = beforeString.lastIndexOf('<');
		const lastCloseBefore = beforeString.lastIndexOf('>');
		/** Фрагмент исходного ХТМЛ после найденной подстроки */
		const afterString = inputHtml.slice(startIndex);
		const firstOpenAfter = afterString.indexOf('<');
		const firstCloseAfter = afterString.indexOf('>');
		const isHtmlAttr =
			// Перед подстрокой есть открывающий тег
			lastOpenBefore !== -1 &&
			// После подстроки есть закрывающий тег
			firstCloseAfter !== -1 &&
			// Перед подстрокой есть открывающий тег и он идёт после закрывающего (либо закрывающего нет, но тогда он будет -1 и спец усл не надо)
			lastOpenBefore > lastCloseBefore &&
			// После подстроки есть закрывающий тег и он идет ДО открывающего (здесь нужно спец усл на -1, т.к. сравнение на "меньше")
			(firstCloseAfter < firstOpenAfter || firstOpenAfter === -1);

		if (!isAria && !isPhone && !isHtmlAttr) {
			// по уму разделитель (точку) надо брать из Intl.NumberFormat
			const ariaLabel = `<span aria-label="${number.split(' ').join('.')}"></span>`;
			const ariaHidden = `<span aria-hidden="true">${number}</span>`;

			finalHtml += inputHtml.slice(processedInputEndIndex, startIndex) + ariaLabel + ariaHidden;
			processedInputEndIndex = endIndex;
		}
	}

	finalHtml += inputHtml.slice(processedInputEndIndex, inputHtml.length);

	return finalHtml;
}
